import styled from "@emotion/native";
import {
    useSafeAreaInsets,
    useSafeAreaFrame,
} from "react-native-safe-area-context";
import Text from "../../components/Text";
import Button from "../../components/Button";

export const Container = styled.View(
    {
        flex: 1,
    },
    () => {
        const insets = useSafeAreaInsets();
        const paddingBottom = insets.bottom > 0 ? insets.bottom : 20;

        return {
            paddingBottom,
        };
    },
);

export const Hero = styled.Image(
    {
        resizeMode: "cover",
        width: "100%",
        height: 270,
    },
    () => {
        const frame = useSafeAreaFrame();
        return {
            width: frame.width,
        };
    },
);

export const Main = styled.View(
    {
        flex: 1,
        marginTop: 50,
        paddingHorizontal: 50,
    },
    () => {
        const insets = useSafeAreaInsets();

        return {
            marginBottom: insets.bottom,
        };
    },
);

export const Title = styled(Text)({});

export const Body = styled(Text)({
    flex: 1,
    marginTop: 10,
});

export const Cta = styled(Button)({
    marginBottom: 50,
});
